import { DOCUMENT } from '@angular/common';
import { Component, Inject, Input } from '@angular/core';
import { Router } from '@angular/router';

import { StructuredBreadcrumb, StructuredDataService } from '@app/base/services/structured-data.service';

import { BtlHelperService } from '../../services/btl-helper.service';
import { IBreadcrumb } from './IBreadcrumb';

@Component({
    selector: 'btl-breadcrumb',
    templateUrl: './breadcrumb.component.html',
    styleUrls: ['./breadcrumb.component.scss'],
})
export class BreadcrumbComponent {
    breadcrumbsList: IBreadcrumb[] = [];
    private param: IBreadcrumb[] = [];
    public jsonLD: StructuredBreadcrumb;
    public breadcrumbNames: { [key: string]: string } = {
        'offres-internet/': 'Offres Internet',

        'test-eligibilite-adsl-vdsl-fibre/': 'Testez votre éligibilité internet',

        'bons-plans/soldes/': 'Bons plans',

        'accessoires/': 'Accessoires',

        'hotspot-tablette/': 'Hotspots et Tablettes',

        'hotspot-tablette-pro/': 'Hotspots et Tablettes',

        'telephones-mobiles/renouvellement/': 'Téléphone mobile',

        'telephones-mobiles/': 'Téléphone mobile',
        'telephones-mobiles-pro/': 'Téléphone mobile',

        'forfaits-mobiles/': 'Forfait mobile',
        'forfaits-mobiles-pro/avec-engagement/': 'Forfait Pro',

        'avec-engagement/': 'Forfait Bouygues Telecom',
        'sans-engagement/': 'Forfait sans engagement',

        'rappelez-moi': 'Me faire rappeler',
    };

    @Input() set paramUrl(val: IBreadcrumb[]) {
        this.param = val;
        if (this.param != null) {
            this.addParamToBreadcrumb();
        }
    }

    constructor(
        private router: Router,
        private btlHelper: BtlHelperService,
        private structuredDataService: StructuredDataService,
        @Inject(DOCUMENT) protected document: Document,
    ) {
        this.updateBreadcrumbNames();
        this.extractBreadcrumbsFromUrl();
    }

    private extractBreadcrumbsFromUrl() {
        let path = `${this.router.url.split('?')[0]}/`;
        let url = '/';
        this.breadcrumbsList.push({ label: 'Accueil', url });
        Object.keys(this.breadcrumbNames).forEach((name: string) => {
            if (path.includes(name)) {
                url += name;
                this.breadcrumbsList.push({ label: this.breadcrumbNames[name], url: url.replace(/\/$/, '') });
                path = path.replace(name, '');
            }
        });
    }

    private updateBreadcrumbNames() {
        const isPro = this.router.url.includes('forfaits-mobiles-pro');
        this.breadcrumbNames['sensation/'] = `Forfait ${isPro ? 'Pro' : ''} + services exclusifs`;
        this.breadcrumbNames['sensation-avantages-smartphone/'] = `Forfait ${isPro ? 'Pro' : ''} + téléphone`;
    }

    private addParamToBreadcrumb(): void {
        this.breadcrumbsList = [];
        this.extractBreadcrumbsFromUrl();
        if (this.param.length > 1) {
            this.breadcrumbsList = this.breadcrumbsList.slice(0, 2);
        }
        this.param.forEach((urlSegment) => {
            this.breadcrumbsList.push({
                label: urlSegment.label,
                url: urlSegment.url,
            });
        });
        this.jsonLD = this.structuredDataService.setBreadcrumbData(this.breadcrumbsList);
    }

    public goToUrl(index: number): void {
        this.btlHelper.navigateToExternalURL(this.breadcrumbsList[index].url);
    }
}
